import { useCallback } from 'react'
import { FormikValues } from 'formik'
import { Status } from '../../__generated__/graphql'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'
import { useConfirmDialogContext } from '../../utils/providers/confirmDialogContext'

export const useArchiveStatusOnSubmit = <T extends FormikValues & { status: Status }>({
  initialStatus,
  canArchive,
  entityName,
  onArchive,
  onSave,
}: {
  initialStatus: Status
  canArchive: boolean
  entityName: string
  onArchive: () => Promise<void>
  onSave: (values: T) => void | Promise<void>
}): ((values: T) => void) => {
  const setConfirmDialogState = useConfirmDialogContext()
  const t = useAppTranslations()

  return useCallback(
    (values: T) => {
      if (canArchive && values.status === Status.Archived && values.status !== initialStatus) {
        setConfirmDialogState({
          message: [t('commons.actions.confirmArchive', { name: entityName })],
          buttonLabel: t('commons.actions.archive'),
          onSubmit: onArchive,
        })
        return
      }

      void onSave(values)
    },
    [canArchive, entityName, initialStatus, onArchive, onSave, setConfirmDialogState, t]
  )
}
